package com.devi3east.bashbuddy.purchase.requests

import kotlinx.serialization.Serializable

@Serializable
data class PurchaseItemRequest(
    val eventId: String,
    val ticketId: String,
    val quantity: Int = 1,
    val shippingSelected: Boolean = false,
    val unitAmountCents: Long? = null
)